import { parseAsFloat, useQueryStates } from "nuqs";

export const paginationFiltersParser = {
  page: parseAsFloat.withDefault(1),
  page_size: parseAsFloat.withDefault(50),
};

export const usePaginationFilters = () => {
  return useQueryStates(paginationFiltersParser);
};
